<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Desert King’s Pregnant Bride</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="aboutAuthorPage" id="ata01"><a id="page02"><p class="aboutAuthorText"><span><span class="bold"><span>ANNIE WEST</span></span> discovered romance early—her childhood best friend’s house was an unending store of Harlequin<sup>®</sup> books—and she’s been addicted ever since. Fortunately she found her own real-life romantic hero while studying at university, and married him. After gaining (despite the distraction) an honors classics degree, Annie took a job in the public service. For years she wrote and redrafted and revised: government plans, letters for cabinet ministers and reports for parliament. Checking the text of a novel is so much more fun!</span></p><p class="aboutAuthorText"><span>Annie started to write romance when she took leave to spend time with her children. Between school activities she produced her first novel. At the same time she discovered Romance Writers of Australia. Since then she’s been active in RWAus writers’ groups and competitions. She attends annual conferences, and loves the support she gets from so many other writers. Her first Harlequin<sup>®</sup> novel came out in 2005.</span></p><p class="aboutAuthorText"><span>Annie lives with her hero (still the same one) and her children at Lake Macquarie, north of Sydney, and spends her time fantasizing about gorgeous men and their love lives. It’s hard work, but she has no regrets!</span></p><p class="aboutAuthorText"><span>Annie loves to hear from readers. You can contact her via her Web site, www.annie-west.com or at annie@annie-west.com.</span></p></a></div>
<a id="page02">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// desertkingspregnantbridethe_ata01.vue?45c1ef04